import { useMemo } from 'react';
import { Cell, Row } from '../../../hooks/useUnrealizedGainLoss';

interface Params {
  rows: Row[] | null | undefined;
  filter: string;
}

export const useFilteredRows = ({ rows, filter }: Params): Row[] | null => {
  return useMemo(() => {
    if (!rows) {
      return null;
    }

    if (!filter) {
      return rows;
    }

    const filterLower = filter.toLowerCase();

    const matchesFilter = (cells: Cell[]): boolean => {
      return cells.some(cell =>
        cell.text
          .toString()
          .toLowerCase()
          .includes(filterLower),
      );
    };

    return rows
      .filter(row => {
        if (row.isTotal) {
          return true;
        }

        const rowMatches = matchesFilter(row.cells);
        const hasMatchingChildren = row.childRows?.some(child => matchesFilter(child.cells));

        const hasMatchingLotDetails = row.childRows?.some(child =>
          child.lotDetailsRows?.some(lot => matchesFilter(lot.cells)),
        );

        return rowMatches || hasMatchingChildren || hasMatchingLotDetails;
      })
      .map(row => ({
        ...row,
        childRows: row.childRows
          ?.map(child => ({
            ...child,
            lotDetailsRows: child.lotDetailsRows?.filter(lot => matchesFilter(lot.cells)),
          }))
          .filter(child => matchesFilter(child.cells) || child.lotDetailsRows?.length),
      }));
  }, [rows, filter]);
};
